import * as yup from 'yup'
import { VALIDATION_PATTERNS } from '../../config'

export const createFileUploadValidationSchema = (extensionLength: number) =>
  yup.object({
    fileName: yup
      .string()
      .trim()
      .matches(
        VALIDATION_PATTERNS.UPLOAD_FILE_NAME,
        'A published file name cannot contain reserved symbols or international characters'
      )
      .max(
        255 - extensionLength - 1,
        'The text is too long, maximum number of characters is 255.'
      )
      .required('File name is required'),
  })
